// extracted by mini-css-extract-plugin
export default {"container":"style_container__8eLoz","block":"style_block__3tyaW","header":"style_header__E56TQ","text":"style_text__-b7AO","button":"style_button__904cm"};